import React, { Component } from 'react'
import { connect } from 'react-redux'
import settings from '../../../settings'
import axios from 'axios'
import { Grid, Row, Col, Overlay, Popover, ButtonToolbar, OverlayTrigger, Button } from 'react-bootstrap'
// import { fetchCollection, fetchDataAnalytics } from '../../common/redux/collectionActions'
import dayjs from 'dayjs'

class LockQueryPopover extends Component {
    constructor(p) {
        super(p)

        this.initialProps = { ...p }

        this.state = {
            queries: this.initialProps.queries,
            generateReportIntervalMinutes: this.initialProps.generateReportIntervalMinutes,
            inputText: '',
            showSaveButton: false
        }
    }

    updateInput = (e) => {
        this.setState({ inputText: e.target.value })
    }

    updatequeries = (e, index) => {
        console.log(`Uppdatera ${index} till ${e.target.value}`)
        var state = { ...this.state, showSaveButton: true }
        state.queries[index] = e.target.value

        this.setState(state)
    }

    getPopoverContent = () => {
        return (
            <div style={{ width: '100%' }}>
                <p>Adresser:</p>
                {this.state.queries.map((address, i) => {
                    return (
                        <div key={i}>
                            <div style={{ width: '90%', float: 'left', marginBottom: 3 }}>
                                <input type="text" value={address} onChange={(e) => this.updatequeries(e, i)}></input>
                            </div>
                            <button style={{ width: '10%', float: 'right' }} onClick={() => { var queries = [...this.state.queries]; var state = { ...this.state, showSaveButton: true }; queries.splice(i, 1); this.setState({ ...state, queries }) }}>
                                X
                            </button>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                    )
                })}
            </div>
        )
    }

    renderSettings = () => {
        return (
            <div>
                <p>Rapport genereras i ett intervall:</p>
                <div>
                    <div style={{ width: '30%', float: 'left' }}>
                        <input type="number" style={{ width: '100%' }} value={this.state.generateReportIntervalMinutes} onChange={(e) => { this.setState({ ...this.state, generateReportIntervalMinutes: e.target.value, showSaveButton: true }) }}></input>
                    </div>
                    <div style={{ width: '70%', textAlign: 'right' }}>
                        Minuter
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
            </div>
        )
    }

    saveChanges = () => {
        this.setState({ isLoading: true })
        axios.put(`${window.MYQLOCX_API}/subject/admin/bi/settings/querywatch`, { queries: this.state.queries, lockId: this.props.lockId, generateReportIntervalMinutes: this.state.generateReportIntervalMinutes }).then(t => {
            this.initialProps = { queries: this.state.queries, generateReportIntervalMinutes: this.state.generateReportIntervalMinutes }

            this.setState({ isLoading: false, showSaveButton: false, hasModified: true })
        }).catch((e) => {
            console.log(e)
            this.setState({ isLoading: false, showSaveButton: false, hasModified: true })
        })
    }

    addAddress = () => {
        var state = { ...this.state, showSaveButton: true }
        state.queries.push(this.state.inputText)
        state.inputText = ''
        this.setState(state)
    }

    prepareExit = () => {
        if (!this.state.hasModified) {
            this.setState({
                showSaveButton: false,
                queries: this.initialProps.queries,
                generateReportIntervalMinutes: this.initialProps.generateReportIntervalMinutes
            })
        }
    }

    render() {
        return (
            <ButtonToolbar>
                <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    rootClose={true}
                    onExit={this.prepareExit}
                    onEnter={() => this.setState({ hasModified: false })}
                    overlay={
                        <Popover style={{ width: '100%' }}
                            id={"popover"}
                            title="Inställningar">
                            {this.renderSettings()}
                            <hr />
                            {this.getPopoverContent()}
                            <hr />
                            <input type="text" onChange={this.updateInput} value={this.state.inputText}></input>
                            <button onClick={this.addAddress}>Lägg till</button>

                            {this.state.showSaveButton ?
                                <div>
                                    <hr />
                                    <button onClick={this.saveChanges} style={{ opacity: this.state.isLoading ? 0.7 : 1 }} disabled={this.state.isLoading}>{this.state.isLoading ? 'Sparar...' : 'Spara ändringar'}</button>
                                </div>
                                :
                                null
                            }

                        </Popover>}>

                    <button>Hantera adresser ({this.state.queries.length})</button>
                </OverlayTrigger>
            </ButtonToolbar>
        )
    }

}


const mapProps = state => {
    return {
    }
}

const mapDispatch = dispatch => {
    return {
    }
}

export default connect(mapProps, mapDispatch)(LockQueryPopover)
